// components/industry-templates/MaritimeEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Anchor, Ship, Waves, TrendingUp } from 'lucide-react';

export const MaritimeEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-blue-600/20 to-cyan-600/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Ship className="w-8 h-8" style={{ color: theme.primary }} />
            Maritime & Shipping
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {industryData?.maritime_solutions?.map((solution: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl">
                <h3 className="text-xl font-bold text-white mb-2">{solution.name}</h3>
                <p className="text-slate-300 text-sm mb-3">{solution.description}</p>
                <Badge style={{ backgroundColor: theme.primary }}>{solution.type}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
